import React from 'react';
import { useL10n } from '@uplift/hooks';
import { ButtonWithArrowLeft, SubtitleOfSection } from '@uplift/ui-v2';
import { UpliftLogoDark } from '@uplift/icons';
import { Box, Container, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Bg from '../../../assets/images/bg_new.png';

const useStyles = makeStyles()(() => ({
  container: {
    paddingBottom: '50px',
    paddingTop: '50px',
    height: 'auto',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E5E5E5',
    flexDirection: 'column',
    maxWidth: '100%',
    backgroundImage: `url(${Bg})`,
  },

  box: {
    maxWidth: '792px',
    width: '100%',
    background: '#FFFFFF',
    boxShadow:
      '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    height: '100vh',
    maxHeight: '656px',
    position: 'relative',
  },
  subTitle: {
    marginTop: '0px',
    fontSize: '24px',
    lineHeight: '133.4%',
  },
  title: {
    maxWidth: '550px',
  },
  logo: {
    marginBottom: '20px',
  },
  button: {
    width: '100%',
    maxWidth: '432px',
    marginTop: '60px',
    height: '42px',
    lineHeight: 1,
  },
  error: {
    position: 'absolute',
    top: '24px',
    right: '16px',
    marginTop: '0px',
  },
}));

export const Page404 = () => {
  const l10n = useL10n();

  const { classes } = useStyles();

  return (
    <Container className={classes.container}>
      <Box className={classes.logo}>
        <UpliftLogoDark />
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        className={classes.box}
      >
        <Typography sx={{ mb: 4 }} variant="h2" className={classes.title} align="center">{l10n.auth.notFound}</Typography>
        <p className={classes.subTitle}>{l10n.auth.subText}</p>
        <ButtonWithArrowLeft
          onClick={() => window.location.replace('https://joinuplift.co')}
          label={l10n.auth.goto}
          variant="contained"
          color="primary"
          className={classes.button}
        />
        <SubtitleOfSection className={classes.error} text={l10n.auth.error} />
      </Box>
    </Container>
  );
};

// eslint-disable-next-line
export default Page404;
